import React from 'react';

import type { FrapiList, FrapiListItem } from '../../../types/frapi-types.js';

import Carousel from '../../components/commonComponents/Carousel.js';
import TeaserList from '../../components/teasers/TeaserList.js';
import { toRelatedTopListTeaser } from '../list/utils/related-top-list.js';

const RestaurantsWidget: React.FC<{
  data: FrapiList;
  isMobile: boolean;
  title?: string;
}> = ({ data, isMobile }) => {
  const lists = data.items?.filter(
    (item) => item.type === 'list',
  ) as FrapiListItem[];

  if (lists.length === 0) {
    return null;
  }

  return (
    <section className="restaurants-wrapper">
      <div className="restaurants-title">
        {data.title ?? data.properties.h1}
      </div>
      <Carousel>
        {lists.map((list) => (
          <TeaserList
            key={list.id}
            {...toRelatedTopListTeaser(list, isMobile, 580, 768)}
          />
        ))}
      </Carousel>
    </section>
  );
};

export default RestaurantsWidget;
